import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RegisterPlayFabUser } from './api';

export const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
};

function CreerCompte() {
    const [displayName, setDisplayName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleCreateAccount = async (e) => {
        e.preventDefault();
        setErrorMessage('');

        if (!validateEmail(email)) {
            setErrorMessage('Veuillez entrer une adresse email valide (ex: exemple@domaine.com).');
            return;
        }

        try {
            const result = await RegisterPlayFabUser(email, password, displayName);
            if (result.success) {
                navigate('/connexion');
            } else {
                setErrorMessage('Erreur lors de la création du compte : ' + result.errorMessage);
            }
        } catch (error) {
            setErrorMessage('Erreur serveur : ' + error.message);
        }
    };

    return (
        <div className="signup-form-container">
            <form className="signup-form" onSubmit={handleCreateAccount}>
                <h2>Créer un compte</h2>
                {errorMessage && <p className="error-message">{errorMessage}</p>}
                <input
                    type="text"
                    placeholder="Nom d'utilisateur"
                    value={displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                    required
                />
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Mot de passe"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button type="submit">Créer un compte</button>
            </form>
        </div>
    );
}

export default CreerCompte;
